<template>
    <font-awesome-icon class="mr-1" :icon="['fas', 'sort']"
                       @click="changeSort"></font-awesome-icon>
</template>
<script>
    export default {
        name:'TableSortControl',
        props:{
            sort: {}

        },
        model: {
            prop: 'sort',
            event: 'input'
        },
        methods: {
            changeSort() {
                let sort = (this.sort === null) ? 'DESC' : this.sort;
                this.$emit('input',(sort === 'ASC') ? 'DESC' : 'ASC')
            }
        }
    }
</script>